<template>
  <div class="payment-popup" v-if="isOpen">
    <div class="payment-popup-body">
      <h3>Your payment<br>was successful!</h3>
      <icon name="popup-pig-icon" />
      <p>Please contact <a href="mailto:support@onlineclasshelp.com">support@onlineclasshelp.com</a> if you have any questions about your order.</p>
      <button @click="togglePopup">GOT IT</button>
    </div>
  </div>
</template>

<script>
import Icon from '@/components/Icon'
import EventBus from '@/utils/event-bus'
export default {
  components: {
    Icon
  },
  data: function () {
    return {
      isOpen: false
    }
  },
  methods: {
    togglePopup () {
      document.body.classList.toggle('popup-opened')
      this.isOpen = !this.isOpen
    }
  },
  mounted () {
    EventBus.$on('PAYMENT_POPUP_OPEN', () => this.togglePopup())
  }
}
</script>

<style lang="scss">
  .payment-popup {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9999;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, .8);

    &-body {
      text-align: center;
      width: 324px;
      height: 385px;
      background-color: var(--primary-white);
      border-radius: 12px;
      box-sizing: border-box;
      padding: 30px 20px;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      margin: auto;
      position: absolute;

      a {
        color: var(--dashed-blue);
        text-decoration: none;
      }

      h3 {
        margin: 0 0 20px 0;
        font-size: 28px;
      }

      p {
        font-size: 14px;
        line-height: 1.6;
      }

      button {
        outline: none;
        margin-top: 10px;
        display: block;
        margin-left: auto;
        margin-right: auto;
        width: 90%;
        padding: 15px;
        border: none;
        border-radius: 8px;
        background-color: var(--primary-green);
        color: var(--primary-white);
        cursor: pointer;
        font-size: 14px;
        transition: background-color .2s ease-out;

        &:hover {
          background-color: var(--primary-green-hover);
        }
      }
    }
  }
</style>
